window.Kbee = {
  render: require('./kbee-embedded').render
}